import { render, staticRenderFns } from "./GoodsLsmiaosha.vue?vue&type=template&id=14be4e48&"
import script from "./GoodsLsmiaosha.vue?vue&type=script&lang=js&"
export * from "./GoodsLsmiaosha.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports